module.exports = __webpack_public_path__ + "static/media/cc_icon-maestro.0a428099.svg";